import { BEARINGX_API_URL } from "~/utils/constants";

export interface ResultBearingXIdFound {
  productInfo: {
    designation: string;
    id: string;
    bearinxClass: string;
  };
  capabilityInfo: {
    frictionCalculation: boolean;
  };
}

export async function fetchBearingXId(bearingXDesignation: string): Promise<ResultBearingXIdFound | undefined> {
  const url = `${BEARINGX_API_URL}product/capabilities?designation=${bearingXDesignation}`;

  const response = await fetch(url, {
    method: "GET",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });

  if (response.ok) {
    return response.json();
  }

  console.error(`Error fetching bearingXId ${bearingXDesignation}: ${response.status}`);
  return undefined;
}
